import React, { useState } from "react"
import axios from "axios"
import { API_URL } from "../../../xhr/xhr.constants"
import { Box, TextField, Button, Typography, Alert } from "@mui/material"
import { useNavigate } from "react-router"

export default function PasswordResetForm() {
  const [email, setEmail] = useState("")
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setSubmitting(true)

    try {
      await axios.post(`${API_URL}/dj-rest-auth/password/reset/`, { email })
      // On success, navigate back to the login page using the app router
      navigate("/login")
    } catch (err) {
      setError("Er is iets misgegaan bij het verzenden van de reset e-mail.")
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Typography component="h1" variant="h5">
          Reset wachtwoord
        </Typography>
      </div>

      <Box sx={{ mt: 1 }}>
        <form onSubmit={handleSubmit}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <TextField
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            label="E-mailadres"
            placeholder="E-mailadres"
            type="email"
            fullWidth
            margin="normal"
            required
          />

          <Box sx={{ mt: 2 }}>
            <Button type="submit" fullWidth variant="contained" disabled={submitting}>
              {submitting ? "Versturen..." : "Reset"}
            </Button>
          </Box>

          <Box sx={{ mt: 2 }}>
            U ontvangt per e-mail een link om uw wachtwoord te herstellen.
          </Box>
        </form>
      </Box>
    </>
  )
}
